import { BydUserAccountInterface } from '../interfaces/byd-user-account.interface';
import { BydUserCompaniesInterface } from '../interfaces/byd-user-companies.interface';
import { BydUserGroupsInterface } from '../interfaces/byd-user-groups.interface';

export class BydUserAccount implements BydUserAccountInterface {
  /**
   *
   */
  public account_id: number;

  /**
   *
   */
  public account_lid: string;

  /**
   *
   */
  public account_firstname: string;

  /**
   *
   */
  public account_lastname: string;

  /**
   *
   */
  public account_email: string;

  /**
   *
   */
  public account_langue: string;

  /**
   *
   */
  public sxd_admin: boolean;

  /**
   * Whether the user is new (used when creating a new user and we don't have an account_id)
   */
  public isNew?: boolean;

  /**
   * Whether the user is director or just admin of an organisation. Only used when linking a user to an organisation
   */
  public isDirector?: boolean;

  /**
   * Property used only inside MAS user update page
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public projects?: any;

  /**
   * Phone number
   */
  public account_phonenumber?: string;

  /**
   * Is project referent
   */
  public is_referent: boolean;

  /**
   * User companies
   */
  public companies: BydUserCompaniesInterface[];

  /**
   * User groups
   */
  public groups: BydUserGroupsInterface[];

  /**
   * Id
   */
  public id?: number;

  /**
   * Email
   */
  public email?: string;

  /**
   * Name
   */
  public name?: string;

  /**
   * Creates an instance of BydUserAccount.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: BydUserAccountInterface = {}) {
    this.account_id = jsonData.account_id || this.account_id;
    this.account_lid = jsonData.account_lid || this.account_lid;
    this.account_firstname = jsonData.account_firstname || this.account_firstname;
    this.account_lastname = jsonData.account_lastname || this.account_lastname;
    this.account_email = jsonData.account_email || this.account_email;
    this.account_langue = jsonData.account_langue || this.account_langue;
    this.sxd_admin = jsonData.sxd_admin || this.sxd_admin;
    this.account_phonenumber = jsonData.account_phonenumber || this.account_phonenumber;
    this.is_referent = jsonData.is_referent || this.is_referent;
    this.companies = jsonData.companies || this.companies;
    this.groups = jsonData.groups || this.groups;
    this.name = `${jsonData.account_firstname} ${jsonData.account_lastname}` || this.name;
    this.id = jsonData.account_id || this.id;
    this.email = jsonData.account_email || this.email;
  }
}
